<template>
  <div id="courseShowNotification">
    <div class="courseShowNotification-wrapper">
      <div class="courseShowNotification-wrapper-title">编辑课程展示</div>
      <div class="courseShowNotification-wrapper-content">
        <div class="content-left">
          <div class="item-upload">
            <img :src="playPath(showInfo.picUrl)"
                 style="width: 350px;height: 200px;">
            <el-upload
              :action="getUploadHeadUrl()"
              :beforeUpload="beforeUploadImage"
              :file-list="filePicList"
              :limit="2"
              :on-change="handlePicChange"
              :on-success="uploadPhotoSuccess"
              :show-file-list="false"
              :with-credentials="true"
              class="upload-demo">
              <el-button class="upload-pic" size="small" type="primary">重新上传</el-button>
            </el-upload>
            <div
              style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #888888;margin-top: 19px;">
              图片要求：
              1、支持jpg、jpeg、gif、png格式，建议单张图片不超过5M
              2、课程封面图最佳尺寸：350*200
            </div>
          </div>
          <div style="width: 100%;text-align: center;height: 14px;margin-top: 10px;line-height: 14px">课程封面
          </div>
        </div>
        <div class="content-right">
          <div class="item-upload">
            <div v-if="showInfo.videoUrl === null || showInfo.videoUrl === ''" class="item-upload-video">
              <img src="../../../../../assets/images/excellentCourse/icon/pre-video.png" style="cursor: pointer">
            </div>
            <div v-if="showInfo.videoUrl !== null && showInfo.videoUrl !== ''" class="item-upload-video">
              <img :src="playPath(showInfo.thumbPath)" style="width: 350px;height: 200px;">
              <img src="../../../../../assets/images/excellentCourse/icon/video.png" style="cursor: pointer;position: absolute" @click.stop="jumpPlay(showInfo.videoUrl)">
            </div>
            <!--<ResourceVideoPlayer v-if="showInfo.videoUrl != null" :resource="resource"></ResourceVideoPlayer>-->
            <div class="upload-video">
              <el-upload
                :action="getUploadHeadUrl()"
                :beforeUpload="beforeUploadVideo"
                :file-list="fileVideoList"
                :limit="2"
                :on-success="uploadVideoSuccess"
                :on-error="uploadVideoError"
                :on-progress="uploadVideoProgress"
                :show-file-list="false"
                :with-credentials="true"
                class="upload-demo">
                <el-button class="upload-video-btn" size="small" type="primary">重新上传</el-button>
              </el-upload>
              <div class="upload-video-btn"
                   style="margin-left: 20px;background-color: rgba(255, 87, 87, 0.5)"
                   @click.stop="delVideo()">删除
              </div>
            </div>
            <div
              style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #888888;margin-top: 19px;">
              视频要求：
              仅支持MP4限制1G以内视频文件
            </div>
          </div>
          <div style="width: 100%;text-align: center;height: 14px;margin-top: 10px;line-height: 14px">课程概述
          </div>
        </div>
      </div>
      <div class="courseShowNotification-wrapper-bottom">
        <div class="courseShowNotification-wrapper-bottom-cal" @click.stop="calc()">取消</div>
        <div class="courseShowNotification-wrapper-bottom-sub" @click.stop="save()">确定</div>
      </div>
    </div>
    <loadingProgressDialog ref="dialogPercent"></loadingProgressDialog>
  </div>
</template>

<script>
import utils from "@/components/tools/utils.js"
import httpCommon from "@/components/tools/request/common.js"
import ResourceVideoPlayer from '@/components/common/resource/player/resource-video-player.vue';
import loadingProgressDialog from "@/components/common/eduUI/loadingProgressDialog.vue";

export default {
  name: "courseShowNotification",
  data() {
    return {
      filePicList: [],
      showInfo: {
        picUrl: '',
        videoUrl: '',
      },
      resource: {},
      fileVideoList: []

    }
  },
  props: {
    dataInfo: {
      type: Object,
      required: true
    },
  },
  components: {
    ResourceVideoPlayer,
    loadingProgressDialog
  },
  methods: {
    playPath(url) {
      return utils.getPlayPath(url)
    },
    jumpPlay(item){
      this.$emit('openVideo',item)
    },
    // 上传
    getUploadHeadUrl() {
      return httpCommon.UPLOAD_FILE_URL;
    },
    handlePicChange(fileList) {
      console.log(fileList)
      if (fileList.length > 1) {
        this.filePicList = fileList.slice(-1)
      }
    },
    beforeUploadImage(file) {
      const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/gif';
      const isLt5M = (file.size / 1024 / 1024) < 5;
      if (!isJPG) {
        utils.notifyError('上传图片只能是 JPG/JPEG/PNG 格式!');
      }
      if (!isLt5M) {
        utils.notifyError('上传图片大小不能超过 5MB!');
      }
      return isJPG && isLt5M;
    },
    uploadPhotoSuccess(res, file) {
      console.log(res)
      console.log(file)
      this.showInfo.picUrl = res.data.path;
      this.filePicList = [];
      this.filePicList.push(file);
      utils.notifySuccess("图片上传成功！")
    },
    handleVideoChange(fileList) {
      this.fileVideoList = [];
      console.log(fileList)
      if (fileList.length > 1) {
        this.fileVideoList = fileList.slice(-1)
      }
    },
    beforeUploadVideo(file) {
      console.log(file)
      const isVideo = file.type === 'video/mp4'
      const isLt1G = (file.size / 1024 / 1024) < 1024;
      if (!isVideo) {
        utils.notifyError('上传视频只能是mp4格式!');
        return false;
      }
      if (!isLt1G) {
        utils.notifyError('上传图片大小不能超过 1G!');
      }else{
        this.$refs.dialogPercent.show();
      }
      return true && isLt1G;
    },
    uploadVideoSuccess(res, file) {
      console.log(res)
      console.log(file)
      this.showInfo.videoUrl = res.data.path;
      this.showInfo.thumbPath = res.data.thumbPath;
      this.fileVideoList = [];
      this.fileVideoList.push(file);
      this.resource = res.data;
      utils.notifySuccess('视频上传成功！');
      this.$refs.dialogPercent.dismisss();
    },
    uploadVideoError(){
      utils.notifyError("上传失败,请重新上传");
      this.$refs.dialogPercent.dismisss();
    },
    uploadVideoProgress(event){
      this.$refs.dialogPercent.refreshPercent(event.percent);
    },
    delVideo() {
      this.resource = {};
      this.fileVideoList = [];
      this.showInfo.videoUrl = null;
      this.showInfo.thumbPath = null;
    },
    calc() {
      this.$emit('calCourseShow')
    },
    save() {
      this.showInfo.id = this.dataInfo.id
      this.$emit('saveCourseShow', this.showInfo)
    }
  },
  created() {
    this.showInfo = {
      picUrl: '',
      videoUrl: '',
      thumbPath:''
    };
    this.showInfo.picUrl = this.dataInfo.picUrl;
    this.showInfo.videoUrl = this.dataInfo.videoUrl;
    this.showInfo.thumbPath = this.dataInfo.thumbPath;
    if (this.dataInfo.videoUrl) {
      this.resource.path = this.dataInfo.videoUrl;
    }
  }
}
</script>

<style scoped>
#courseShowNotification {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
}

.courseShowNotification-wrapper {
  width: 840px;
  height: 520px;
  background: #FFFFFF;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}

.courseShowNotification-wrapper-title {
  width: 840px;
  height: 41px;
  background: #4E54E1;
  border-radius: 10px 10px 0px 0px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}

.courseShowNotification-wrapper-content {
  width: 100%;
  height: 424px;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.content-left {
  width: 390px;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.upload-pic {
  width: 350px;
  height: 36px;
  background: rgba(85, 155, 255, 0.5);
  border-radius: 4px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  border-color: rgba(85, 155, 255, 0.5);
}

.content-right {
  width: 390px;
  height: 100%;
  margin-left: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.item-upload {
  width: 390px;
  height: 360px;
  background: #F5F5F5;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.item-upload-video {
  width: 350px;
  height: 200px;
  background: #DDDDDD;
  border-radius: 4px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.upload-video {
  width: 100%;
  height: 36px;
  margin-top: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.upload-video-btn {
  width: 165px;
  height: 36px;
  background: rgba(85, 155, 255, 0.5);
  border-radius: 4px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FEFEFF;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-color: rgba(85, 155, 255, 0.5);
  cursor: pointer;
}

.courseShowNotification-wrapper-bottom {
  width: 100%;
  height: 55px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.courseShowNotification-wrapper-bottom-cal {
  width: 140px;
  height: 36px;
  background: #A6A9F0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.courseShowNotification-wrapper-bottom-sub {
  width: 140px;
  height: 36px;
  background: #FBA62D;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  margin-left: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/deep/ .video-player-wrapper .vjs-control-bar {
  font-size: 6px;
}

</style>



// WEBPACK FOOTER //
// src/components/excellentCourse/courseIntroduction/components/courseIntroduction/courseShowNotification.vue